import React from 'react';
import { Link } from 'gatsby';

export default function StoryBlokLink({
  to, children, ...props
}) {
  // Check if the URL starts with http, https, or www.
  const isExternal = to.startsWith('http://')
                    || to.startsWith('https://')
                    || to.startsWith('www.')
                    || to.startsWith('//');

  if (!isExternal) {
    const url = to.startsWith('/') ? to : `/${to}`;
    return (
      <Link
        to={url}
        {...props}
      >
        {children}
      </Link>
    );
  }

  // Ensure the URL has a proper protocol
  const href = to.startsWith('www.') ? `https://${to}` : to;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      {children}
    </a>
  );
}
